<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                :style="($i18n.locale == 'ar') ? '' : 'text-align: left'">
                {{ label }}
            </h4>
            <div class="col-12 pd-0" style="padding:0">
                <input 
                    id="input"
                    class="form-control text-lowercase" 
                    :type="type" 
                    v-model="row.input"
                    @paste="onPaste"
                    v-on:input="onChange">
               <!--  @keydown.space.prevent  -->
            </div>
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'CardInput',
    props: [
        'label',
        'type',
        'input'
    ],
    data(){
        return {
            row: {
                input: this.$props.input
            },
        }
    },
    mounted() {},
    methods: {

        onChange(){
            const data = {
                input: this.row.input
            }
            this.$emit('inputChange', data);
        },
        onPaste(){
            let str = this.row.input;
            this.preventSpace(str);
        },
        preventSpace(str){
            if(!str) {
                let str = this.row.input;
                this.row.input = str.replace(/\s+/g, '-');
            } else {
                this.row.input = str.replace(/\s+/g, '-');
            }
        },

    }
}
</script>
